'use strict';

module.exports = {
    errors: {
        VALIDATE_NO_SURL: 'No stored SURL or SURL argument to validate',
        VALIDATE_UNEXPECTED_RESPONSE: 'Validate call received an unexpected response',
        NOT_LOGGED_IN: 'You are not logged in',

        CATEGORY_LIST_INVALID_INIT_DATA: 'Invalid data supplied to CategoryList; requires raw array data from Categories_XML call',
        CATEGORY_INVALID_INIT_DATA: 'Invalid data supplied to Category; requires raw category data from Categories_XML call',
        CATEGORY_CREATE_INVALID_ARGS: 'Invalid arguments for createCategory; expects category name',
        CATEGORY_EDIT_INVALID_ARGS: 'Invalid arguments for editCategory; expects category ID and config options',
        CATEGORY_EDIT_REQUIRE_TITLE: 'Invalid arguments for editCategory; requires TITLE to be defined',
        CATEGORY_DELETE_INVALID_ARGS: 'Invalid arguments for deleteCategory; expects category ID',

        LIGHTBOX_CREATE_INVALID_ARGS: 'Invalid arguments for createLightbox; expects lightbox name',
        LIGHTBOX_EDIT_INVALID_ARGS: 'Invalid arguments for editLightbox; expects lightbox ID and config options',
        LIGHTBOX_DELETE_INVALID_ARGS: 'Invalid arguments for deleteLightbox; expects lightbox ID',
        LIGHTBOX_ADD_INVALID_ARGS: 'Invalid arguments for addToLightbox; expects lightbox ID and array of UMO IDs',
        LIGHTBOX_MOVE_BETWEEN_INVALID_ARGS: 'Invalid arguments for moveBetweenLightboxes; expects fromLightbox ID, toLightboxID and array of UMO IDs',
        LIGHTBOX_DELETE_FROM_INVALID_ARGS: 'Invalid arguments for deleteFromLigthbox; expects lightbox ID and array of UMO IDs',
        LIGHTBOX_DELETE_ALL_FROM_INVALID_ARGS: 'Invalid arguments for deleteAllFromLigthbox; expects lightbox ID',

        METADATA_INVALID_INIT_DATA: 'Invalid data supplied to Metadata; requires raw array data from image_query call',
        METADATA_LIST_INVALID_INIT_DATA: 'Invalid data supplied to MetadataList; requires raw array data from image_query call',

        METATAG_INVALID_ARGS: 'Invalid arguments for getMetatags; requires config e.g. TAG_FOR_PROFILE_EDITED',

        MOVE_UMOS_INVALID_ARGS: 'Invalid arguments for moveUMOs; expects single UMO ID as string or array of UMO IDs and category ID',
        MOVE_UMOS_MULTIPLE_ERROR: 'One or more objects failed to move. Please verify and try again.',

        PICTIONJS_INVALID_INIT_DATA: 'Invalid data supplied to PictionJS',

        UMO_INVALID_INIT_DATA: 'Invalid data supplied to UMO; requires raw array data from image_query call',
        UMO_LIST_INVALID_INIT_DATA: 'Invalid data supplied to UMOList; requires raw array data from image_query call',
        UMO_DERIVATIVE_INVALID_INIT_DATA: 'Invalid data supplied to UMODerivative; requires raw array data from image_query call',
        UMO_DERIVATIVE_LIST_INVALID_INIT_DATA: 'Invalid data supplied to UMODerivativeList; requires raw array data from image_query call',
        GETUMOS_INVALID_ARGS: 'Invalid arguments given to .getUMOs'
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/piction-js/lib/constants/messages.js
// module id = 715
// module chunks = 0 1 2 5 6